import { useState, useRef, useEffect } from 'react';
import Media from 'react-media';

import { DesktopCluster, MobileCluster } from '../Cluster';

import { useTheme } from '@simplywallst/ui-core';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { useResponsiveWidth } from '@/hooks/useResponsiveWidth';

import type { NormalisedDiversification } from '../../hooks/useNormalisedDiversification';

interface Props {
  data: NormalisedDiversification;
  holdingsCount: number;
  onLabelClick?: () => void;
}

export const Chart = ({ data, holdingsCount, onLabelClick }: Props) => {
  const theme = useTheme();
  const { ref: responsiveWidthRef, width } = useResponsiveWidth();
  const responsiveHeightRef = useRef<SVGGElement>(null);

  const [height, setHeight] = useState(0);

  const { isMobile, isTablet } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({
    defaultMatches: isMobile || isTablet,
  });

  useEffect(() => {
    if (responsiveHeightRef.current) {
      setHeight(responsiveHeightRef.current.getBBox().height + theme.x3);
    }
  }, [data, isMobileScreen, theme]);
  return (
    <div ref={responsiveWidthRef}>
      <svg width="100%" height={height} data-cy-id="diversification-chart">
        <Media query={{ minWidth: theme.lgMin }}>
          {(match) => {
            return match ? (
              <DesktopCluster
                ref={responsiveHeightRef}
                data={data}
                holdingsCount={holdingsCount}
                width={width}
                onLabelClick={onLabelClick}
              />
            ) : (
              <MobileCluster
                ref={responsiveHeightRef}
                data={data}
                holdingsCount={holdingsCount}
                width={width}
                onLabelClick={onLabelClick}
              />
            );
          }}
        </Media>
      </svg>
    </div>
  );
};
